<template>
	<div>
		<span class="ml-3 mr-5" v-if="show_label">Période</span>
		<v-menu
			:value="menu"
      :close-on-click="false"
			:close-on-content-click="false"
			:nudge-right="40"
      persistence
			transition="scale-transition"
			offset-y
		>
			<template v-slot:activator="{ on, attrs }">
        <v-text-field
          dense
          v-model="dateRangeText"
          prepend-icon="mdi-calendar"
          v-bind="attrs"
          v-on="on"
          @click="openCalendar"
          @click:prepend="resetCalendar"
          readonly
        ></v-text-field>
			</template>

			<v-date-picker
        v-if="menu"
				v-model="dates"
        :min="min_date"
        :max="max_date"
        range
        scrollable
        elevation="10"
			>
        <v-spacer></v-spacer>
        <v-btn text color="black" @click="cancelDate">Annuler</v-btn>
        <v-btn text color="primary" @click="saveDate">Rafraîchir</v-btn>
      </v-date-picker>
		</v-menu>
	</div>
</template>

<script>

import dt_form from "../../utils/date_tools";

export default {
	props: {
    min_date: {
      type: String,
      default: "",
    },
    max_date: {
      type: String,
      default: "",
    },
		show_label: {
			type: Boolean,
			default: true,
		},
    store_cal_event: {
      type: String,
    },
    store_date: {
      type: Object,
    },
    store_date_commit: {
      type: String
    },
    default_last_month: {
      type: Boolean,
      default: false
    }
	},

  data() {
		return {
      dates: [this.store_date.start, this.store_date.end],
      dateRangeText: `${this.store_date.start} -> ${this.store_date.end}`,
      menu: false,
      items: ['< 1 mois', '< 6 mois', '< 1 an', 'Toute la période'],
		};
	},

	methods: {
    setDateRange(startDate, endDate) {
      if (startDate !== undefined && endDate !== undefined) {
        const checkedDates = this.checkSortDate(startDate, endDate)
        this.dateRangeText = `${checkedDates['start']} -> ${checkedDates['end']}`
      } else {
        this.dateRangeText = `${this.store_date.start} -> ${this.store_date.end}`
      }
    },

    checkSortDate(startDate, endDate) {
      if (startDate !== undefined && endDate !== undefined) {
        return {
          "start": (startDate < endDate) ? startDate : endDate,
          "end": (startDate < endDate) ? endDate : startDate
        }
      } else {
        return {"start": null, "end": null}
      }
    },

    resetCalendar() {
      let checkedDates
      if (this.default_last_month) {
        const end_dt = dt_form.dateFormat(this.max_date, "endMonth", "sys")
        const start_dt = dt_form.dateFormat(this.max_date, "startMonth", "sys")
        checkedDates = this.checkSortDate(start_dt, end_dt)
      } else {
        checkedDates = this.checkSortDate(this.min_date, this.max_date)
      }
      this.updateDates('START', checkedDates['start'])
      this.updateDates('END', checkedDates['end'])
      this.setDateRange(checkedDates['start'], checkedDates['end'])
      this.$store.commit(this.store_cal_event, true)
    },

    openCalendar() {
      this.dates[0] = this.store_date.start
      this.dates[1] = this.store_date.end
      this.menu = true
    },

    cancelDate() {
      this.menu = false
      const checkedDates = this.checkSortDate(this.store_date.start, this.store_date.end)
      this.dates[0] = checkedDates['start']
      this.dates[1] = checkedDates['end']
    },

    saveDate() {
      this.menu = false
      const checkedDates = this.checkSortDate(this.dates[0], this.dates[1])
      this.updateDates('START', checkedDates['start'])
      this.updateDates('END', checkedDates['end'])
      this.setDateRange(checkedDates['start'], checkedDates['end'])

      this.$store.commit(this.store_cal_event, true)
    },

		updateDates(key, value = null) {
      if (value) {
        this.$store.commit(`${this.store_date_commit}_${key.toUpperCase()}`, value);
      }
		},
	},
};

</script>
<style>
.v-menu__content {
  min-width: 250px; /* or adjust to fit your design */
}

.v-date-picker {
  width: 100%;
}

.v-text-field {
  padding-right: 15px; /* Adjust as needed */
}
</style>